<template>
    <div class="container" id="curriculum_nqt_box_right">

        <div class="_controll_top">
            <template v-if="!loading">
                <div class="slider-zoom" v-show="lesson.type == $CONST.VIDEO.MATERIAL.TYPE.PDF">
                    <span class="nqt-precent" @click="resetZoom()">{{precent.toFixed(1)}}x</span>
                    <el-slider v-model="value1" :step="step"></el-slider>
                </div>
                <div class="btn-item _top" v-if="isContentFlag == 1">
                    <!-- Show all pages -->
                    <span class="pgn">{{ isPage }}/{{ pags.length }}</span>
                    <div class="select-new select-custom">
                        <select v-model="pagItem" @change="changePhase(pagItem)" id="nqt_select">
                            <option v-for="(item, index) in pags" :value="item" :key="index" :disabled="!item.enable" :class="{disabled_nqt: !item.enable}">
                                {{item.page}}
                            </option>
                        </select>
                    </div>
                </div>
            </template>
        </div>

        <div class="lesson-content" id="div-right" ref="nqt-content">
            <template v-if="!loading">
                <template v-if="isContentFlag == 1">
                    <pdf ref="pdf" v-if="lesson.type == $CONST.VIDEO.MATERIAL.TYPE.PDF" 
                        v-bind="{value, pdfData}"
                        @reload="resetZoom()">
                    </pdf>  
                    <video-player v-if="lesson.type == $CONST.VIDEO.MATERIAL.TYPE.VIDEO"
                        class="vjs-custom-skin"
                        ref="videoPlayer"
                        :options="playerOptions"
                        @ready="onPlayerReadied"
                        @timeupdate="onTimeupdate">
                    </video-player>
                    <img v-if="lesson.type == $CONST.VIDEO.MATERIAL.TYPE.IMG" :src="lesson.path"/>
                    <iframe
                        v-if="lesson.type == $CONST.VIDEO.MATERIAL.TYPE.YOUTUBE"
                        width="100%" 
                        height="calc(100% - 100px)" 
                        :src="lesson.srcYoutube" 
                        title="YouTube video player" 
                        frameborder="0" 
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" 
                        allowfullscreen>
                    </iframe>
                </template>
                <template v-if="isContentFlag == 0">
                    <img src="../../../static/images/noresult.jpg"/>
                </template>
            </template>
        </div>

        <div class="_controll">

            <!-- Btn: back -->
            <div class="btn-item" @click="back()">
                <img src="/static/images/icon-back-1.png"/>
            </div>

            <template v-if="!loading">

                <!-- Btn: previous -->
                <div class="btn-item" @click="previous()" v-if="isContentFlag == 1">
                    <img v-if="lesson.no == 1 && lesson.num == 1 && material.prevId == null" src="/static/images/back-den.png" alt="previous">
                    <img v-else src="/static/images/icon-back.png" alt="previous">
                </div>

                <!-- Btn: toogle menu -->
                <div class="btn-item" @click="setShowMenu(!showMenu)">
                    <img src="/static/images/mucluc-xanh.png" alt="exercise">
                </div>

                <!-- Btn: excicre -->
                <div class="btn-item" @click="exercise()" v-if="isContentFlag == 1 && (lesson.exerciseState == $CONST.VIDEO.MENU.HAVE_EXERCISE && lesson.isExercise != $CONST.VIDEO.MENU.EXERCISE_NONE)">
                    <img src="/static/images/icon-bt.png" alt="exercise">
                </div>

                <!-- Btn: next -->
                <div class="btn-item xoay" @click="next()" v-if="isContentFlag == 1">
                    <img v-if="(lesson.no == material.contents.length && lesson.num == lesson.mnum && material.nextId == null) || (lesson.no == material.contents.length && material.nextId == null && lesson.type != $CONST.VIDEO.MATERIAL.TYPE.PDF)" src="/static/images/back-den.png" alt="next">
                    <img v-else src="/static/images/icon-back.png" alt="next">
                </div>

                
                <!-- FIX: TODO: IIIINGU -->
                <template v-if="isContentFlag == 0">
                    
                    <!-- Btn: previous -->
                    <div class="btn-item" @click="previousDataNone()">
                        <img v-if="material.prevId == null" src="/static/images/back-den.png" alt="previous">
                        <img v-else src="/static/images/icon-back.png" alt="previous">
                    </div>

                    <!-- Btn: next -->
                    <div class="btn-item xoay" @click="nextDataNone()">
                        <img v-if="material.nextId == null" src="/static/images/back-den.png" alt="next">
                        <img v-else src="/static/images/icon-back.png" alt="next">
                    </div>

                    <!-- Btn: excicre -->
                    <div class="btn-item ngu_4" v-if="checkMaterialExcercise()" @click="exerciseIIIINGU()">
                        <img src="/static/images/icon-bt.png" alt="exercise">
                    </div>
                </template>
            </template>
        </div>

        <!-- Loading -->
        <loading class="loading--lesson" :showLoading="loading" />
    </div>
</template>

<script>
    import nqtPdf from "@/components/curriculum/pdfVn"
    import loading from "@/components/loading/loading"
    import { mapState, mapMutations } from "vuex"
    export default {
        data() {
            return {
                material: {},
                activeID: null,
                isContentFlag: 0,
                value1: 0,
                value: 0,
                step: 2,
                pdfData: null,
                page: 1,
                loading: true,
                playerOptions: {
                    overNative: true,
                    autoplay: false,
                    controls: true,
                    techOrder: ['html5'],
                    html5: { hls: { withCredentials: false } },
                    playbackRates: [0.5, 0.75, 1.0, 1.5, 1.75, 2.0],
                    sources: [
                        {
                            withCredentials: false,
                            type: this.checkGeneralEnvironment == 3 ? 'application/x-mpegURL' : '',
                            src: ''
                        }
                    ],
                    poster: '/static/images/logo.png'
                },                
				pags: [],
				isPage: 1,
				pagItem: null,
                jumpS: false,
                templateYoutubeSrc: "https://www.youtube.com/embed/"
            };
        },
        components: {
            pdf: nqtPdf,
            loading
        },
        props: {
            course: {
                type: Object,
                default: {},
            }
        },
        created() {
            this.init();
        },        
        updated() {
            const self = this;
            if (!this.loading) {
                let kPag = this.pags.findIndex(item => item.id == this.activeID && item.pageReal == this.page);
                if (this.pags[kPag]) {
                    let index = this.pags[kPag].page - 1;
                    document.getElementById("nqt_select").selectedIndex = index;
                }
            }

            
            var theElement = document.querySelector(".el-slider__runway");

            if (theElement) {
                theElement.addEventListener("touchend", tapOrClick, false);
            }            

            function tapOrClick(event) {
                //handle tap or click.

                if (self.value != self.value1) {
                    self.value = self.value1;
                }

                event.preventDefault();
                return false;
            }
        },
        computed: {
            lesson () {
                if (this.isContentFlag == 1) {
                    const key = this.material.contents.findIndex(item => item.id == this.activeID);
                    return this.material.contents[key];
                } else {
                    return {};
                }
            },

            ...mapState({
                mobile: (state) => state.header.mobile,
                menuList: (state) => state.learn.menuList,
                activeMenu: (state) => state.learn.activeID,
                reload: (state) => state.learn.reload,
                showMenu: (state) => state.learn.showMenu
            }),

            precent () {
                let scale = 1;

                let percent = (this.value / 5) * 0.1;
                
                return scale + percent;
            },

            maxSelect () {
                if (this.isContentFlag == 1) {
                    const key = this.material.contents.findIndex(item => item.id == this.activeID);
                    var x = [];
                    for (var i = 0; i < this.material.contents[key].currentNum; ++i) {
                        x[i] = i + 1;
                    }
                    return x;
                } else {
                    return 1;
                }
            }
        },
        async destroyed() {
            if (this.lesson.mnum > this.lesson.currentNum && this.lesson.currentNum != 1) {
                await this.update({
                    materialId: this.lesson.id,
                    courseOutlineId: this.course.activeID,
                    num: this.lesson.currentNum,
                    isCommitExam: true
                });
            }
        },
        watch: {
            page (newPage) {
                this.isPage = this.findPage();
                if (newPage != this.lesson.num) {
                    if (this.$refs.pdf != undefined && this.$refs.pdf != null) {
                        this.jump(newPage);
                    }
                }
            },

            async activeID (value, prevID) {

                // Update :video prev
                const keyVideo = this.material.contents.findIndex(item => item.id == prevID);
                if (keyVideo >= 0) {
                    if (this.material.contents[keyVideo].type == this.$CONST.VIDEO.MATERIAL.TYPE.VIDEO) {
                        if (this.material.contents[keyVideo].currentNum != this.material.contents[keyVideo].mnum && this.material.contents[keyVideo].currentNum != 1) {
                            await this.update({
                                materialId: prevID,
                                courseOutlineId: this.course.activeID,
                                num: this.material.contents[keyVideo].currentNum,
                                isCommitExam: true
                            });
                        }
                    }
                }

                // Enable loading
                this.loading = true;

                const key = this.material.contents.findIndex(item => item.id == value);
                this.page = this.material.contents[key].num;
                let currentPage = this.material.contents[key].currentNum;

                this.page = this.material.contents[key].type != 2 ? 1 : this.page;

                let material = await this.getCourseMaterialObject({courseMaterialId: value});
                
                // #53
                let companyId = window.sessionStorage.getItem("companyId");
                this.updateAccessInfo({companyId: companyId, contentID: value});

                // Set params for pdf
                this.pdfData = material;
                this.pdfData['first'] = this.jumpS ? this.pagItem.pageReal : this.page;
                let kPag = this.pags.findIndex(item => item.id == this.activeID && item.pageReal == this.page);
                if (kPag >= 0) {
                    this.pags[kPag].enable = true;
                }
                // if (this.jumpS) {
                //     this.page = this.pagItem.pageReal;
                // } else {                
                //     this.isPage = this.findPage();
                // }

                if (this.jumpS) {
                    this.page = this.pagItem.pageReal;
                }
                this.jumpS = false;

                // Set params for video
                this.playerOptions.sources[0].src = material.path;

                // Update num page
                if (currentPage == 0) {
                    let status = await this.update({
                        materialId: value,
                        courseOutlineId: this.course.activeID,
                        num: 1,
                        isCommitExam: true
                    });

                    // Reload menu: status
                    if (status == 1) {
                        this.material.contents[key].currentNum = 1;
                        this.setReload(!this.reload);
                    }
                }

                this.resetZoom();

                this.isPage = this.findPage();

                // Disable loading
                this.loading = false;
            }
        },
        methods: {
            init: async function () {
                let material = await this.getMaterial({courseOutlineId: this.course.activeID, languageType: this.$lang()});
                if (material.materialList != null && material.materialList.length) {
                    // format src of lesson type youtube
                    material.materialList.forEach(el => {
                        if (Number(el.materialType) == 4) {
                            let temp = el.materialName.split("https://youtu.be/");
                            el.materialName = this.templateYoutubeSrc + temp[1];
                        }
                    });

                    this.material = this.convert(material);

                    const fisrtItem = this.material.contents.filter(item => item.no == 1);
                    this.activeID = fisrtItem[0].id;

                    this.pags = this.convertDataPags(this.material.contents);

                    this.isContentFlag = 1;
                } else {
                    this.material = {
                        id: material.courseOutlineId,
                        nextId: material.nextOutlineId,
                        prevId: material.preOutlineId,
                        chapterName: material.chapterName,
                        contents: []
                    };

                    // Disable loading
                    this.loading = false;
                    this.$confirm(this.$t('js.dataNone'),
                        window.vm.$i18n.t("new.title86"),
                        {
                            cancelButtonClass: "btn-nqt---show",
                            type: 'warning'
                        }                            
                    ).then(() => {}).catch(() => {});
                }
            },

            ...mapMutations("learn", ["setActiveID", "setReload", "setShowMenu"]),

            getMaterial: function (params) {
                return new Promise((resolve, reject) => {
                    this.$api
                        .post("/courseStudy/getCourseMaterialNew", params)
                        .then((response) => {
                            resolve(response.data);
                        })
                        .catch((err) => {
                            reject(err.response);
                        });
                });
            },

            convert: function (data) {
                const contents = data.materialList.reduce((a, v) => {
                    let firstPage = v.num == v.mnum || v.num == 0 ? 1 : v.num;
                    let path = Number(v.materialType) == 3 ? v.materialPath : null;
                    let srcYoutube = Number(v.materialType) == 4 ? v.materialName : null;
                    a.push({
                        id: v.id,
                        type: Number(v.materialType),
                        path: path,
                        mnum: v.mnum,
                        no: v.no,
                        num: firstPage,
                        currentNum: v.num,
                        learningState: v.learningState,
                        exerciseState: v.exerciseState,
                        isExercise: v.isExercise,
                        srcYoutube: srcYoutube,
                    });
                    return a;
                }, []);

                return {
                    id: data.courseOutlineId,
                    nextId: data.nextOutlineId,
                    prevId: data.preOutlineId,
                    chapterName: data.chapterName,
                    contents: contents
                };
            },

            // Control
            previous: function () {
                let page = this.lesson.num;
                let no = this.lesson.no;
                let type = this.lesson.type;

                // With IMG, VIDEO, Link YOUTUBE
                if (type == this.$CONST.VIDEO.MATERIAL.TYPE.VIDEO || type == this.$CONST.VIDEO.MATERIAL.TYPE.IMG || type == this.$CONST.VIDEO.MATERIAL.TYPE.YOUTUBE) {

                    if (no != 1) {
                        // Change active content masterial: previous ID
                        let key = no - 2;
                        this.activeID = this.material.contents[key].id;
                    } else {
                        // Change active masterial ID with vuex
                        // previous ID
                        if (this.material.prevId != null) {
                            this.setActiveID(this.material.prevId);
                        }
                    }
                }

                // With PDF
                if (type == this.$CONST.VIDEO.MATERIAL.TYPE.PDF) {
                    if (no == 1) {
                        if (page > 1) {
                            page -= 1;
                            this.page = page;
                            this.jump(page);
                        } else {
                            // Change active masterial ID with vuex
                            // previous ID
                            if (this.material.prevId != null) {
                                this.setActiveID(this.material.prevId);
                            }
                        }
                    } else {
                        if (page > 1) {
                            page -= 1;
                            this.page = page;
                            this.jump(page);
                        } else {
                            // Change active content masterial: previous ID
                            let key = no - 2;
                            this.activeID = this.material.contents[key].id;
                        }
                    }
                }
            },

            next: function () {
                let page = this.lesson.num;
                let currentNum = this.lesson.currentNum;
                let totalPage = this.lesson.mnum;
                let no = this.lesson.no;
                let type = this.lesson.type;

                // With IMG, VIDEO, Link YOUTUBE
                if (type == this.$CONST.VIDEO.MATERIAL.TYPE.VIDEO || type == this.$CONST.VIDEO.MATERIAL.TYPE.IMG || type == this.$CONST.VIDEO.MATERIAL.TYPE.YOUTUBE) {

                    if (totalPage > currentNum && type == this.$CONST.VIDEO.MATERIAL.TYPE.VIDEO) {
                        this.$confirm(this.$t('new.title87'),
                            window.vm.$i18n.t("new.title86"),
                            {
                                cancelButtonClass: "btn-nqt---show",
                                type: 'warning'
                            }                            
                        ).then(() => {
                        }).catch(() => {
                        });
                        return
                    }
                    

                    if (no != this.material.contents.length) {
                        // Change active content masterial: next ID
                        this.activeID = this.material.contents[no].id;
                    } else {
                        // Change active masterial ID with vuex
                        // next ID
                        if (this.material.nextId != null) {
                            this.setActiveID(this.material.nextId);
                        }
                    }
                }

                // With PDF
                if (type == this.$CONST.VIDEO.MATERIAL.TYPE.PDF) {
                    if (no != this.material.contents.length) {
                        if (page < totalPage) {
                            page += 1;
                            this.page = page;
                            this.jump(page);
                            
                            let kPag = this.pags.findIndex(item => item.id == this.activeID && item.pageReal == page);
                            if (kPag >= 0) {
                                this.pags[kPag].enable = true;
                            }
                        } else {
                            // Change active content masterial: next ID
                            this.activeID = this.material.contents[no].id;
                        }
                    } else {
                        if (page < totalPage) {
                            page += 1;
                            this.page = page;
                            this.jump(page);

                            let kPag = this.pags.findIndex(item => item.id == this.activeID && item.pageReal == page);
                            if (kPag >= 0) {
                                this.pags[kPag].enable = true;
                            }
                        } else {
                            // Change active masterial ID with vuex
                            // next ID
                            if (this.material.nextId != null) {
                                this.setActiveID(this.material.nextId);
                            }
                        }
                    }
                }
            },

            jump: async function (page) {
                this.lesson.num = page;
                this.material.contents[this.lesson.no - 1].num = page;
                if (this.lesson.type == this.$CONST.VIDEO.MATERIAL.TYPE.PDF) {
                    this.$refs.pdf.jump(page);
                }

                // Update page num local
                if (page > this.lesson.currentNum && page != this.lesson.mnum && this.lesson.currentNum != this.lesson.mnum && page != 1) {
                    this.material.contents[this.lesson.no - 1].currentNum = page;
                }

                // Update page num
                if (page == this.lesson.mnum && this.lesson.currentNum != this.lesson.mnum && page != 1) {
                    let status = await this.update({
                        materialId: this.lesson.id,
                        courseOutlineId: this.course.activeID,
                        num: page,
                        isCommitExam: true
                    });

                    // Reload menu: status
                    if (status == 1) {
                        this.material.contents[this.lesson.no - 1].currentNum = page;
                        this.setReload(!this.reload);
                    }
                }
            },

            zoomIn: function () {
                if (this.value == 100) return;
                this.value += 5;
            },

            zoomOut: function () {
                if (this.value == 0) return;
                this.value -= 5;
            },

            back: function () {
                let outlineInfo = {
                    courseId: this.course.id,
                    courseName: this.course.name
                };
                this.$router.push({
                    path: "/home/curriculum",
                    query: {
                    outlineInfo: JSON.stringify(outlineInfo),
                    },
                });
            },

            exercise: async function () {
                let material = await this.getMaterial({courseOutlineId: this.course.activeID, languageType: this.$lang()});
                let data = this.convert(material);

                if (data.contents.some(item => item.learningState != 0)) {
                    this.$confirm(this.$t('new.title104'),
                        window.vm.$i18n.t("new.title86"),
                        {
                            cancelButtonClass: "btn-nqt---show",
                            type: 'warning'
                        }                            
                    ).then(() => {
                    }).catch(() => {
                    });
                    return
                }

                this.$router.push({
                    path: "/home/task/answer",
                    query: {
                        outlineInfo: JSON.stringify({
                            courseId: this.course.id, 
                            courseName: this.course.name,
                            courseOutlineId: this.course.activeID,
                            chapterName: this.material.chapterName
                        }),
                    },
                });
            },

            onPlayerReadied: function () {
                // console.log(`Load video completed !!!`);
            },

            onTimeupdate: async function (e) {
                // console.log('time: ', e.cache_.currentTime);
                let time = Math.ceil(e.cache_.currentTime);

                // Update page num
                if (this.lesson.mnum == time && this.lesson.mnum != this.lesson.currentNum && this.lesson.currentNum != 1 ) {
                    let status = await this.update({
                        materialId: this.lesson.id,
                        courseOutlineId: this.course.activeID,
                        num: this.lesson.mnum,
                        isCommitExam: true
                    });

                    // Reload menu: status
                    if (status == 1) {
                        this.material.contents[this.lesson.no - 1].currentNum = this.lesson.mnum;
                        this.setReload(!this.reload);
                    }
                } else {
                    
                    if (time > this.lesson.currentNum && time > 1 && this.lesson.mnum >= time) {
                        let sprendTime = time > this.lesson.mnum ? this.lesson.mnum : time;
                        this.material.contents[this.lesson.no - 1].currentNum = sprendTime;
                    }
                }
            },

            getCourseMaterialObject: function (params) {
                return new Promise((resolve, reject) => {
                    this.$api
                    .post("/courseStudy/getCourseMaterialObject", params)
                    .then((response) => {
                        resolve({
                            blob: response.data.blob,
                            type: Number(response.data.materialType),
                            name: response.data.name,
                            path: response.data.materialPath,
                            size: response.data.fileSize
                        });
                    }).catch( err => {
                        reject(err.response);
                    });
                });
            },

            // #53
            updateAccessInfo: function (params) {
                return new Promise((resolve, reject) => {
                    this.$api
                    .post("/courseStudy/updateAccessInfo", params)
                    .then((response) => {
                        resolve(response.data);
                    }).catch( err => {
                        reject(err.response);
                    });
                });
            },

            // Update num page
            update: function (params) {
                return new Promise((resolve, reject) => {
                    this.$api
                    .post("/courseStudy/updateStudyRecord", params)
                    .then((response) => {
                        resolve(response.data);
                    }).catch( err => {
                        reject(err.response);
                    });
                });
            },
            
            // TODO: IIIINGU
            checkMaterialExcercise: function () {
                let key = this.menuList.findIndex(item => item.id == this.activeMenu);
                if (key >= 0) {
                    if (this.menuList[key].isExercise > 0 && this.menuList[key].learningState == null) {
                        return true;
                    }
                }
                return false;
            },

            exerciseIIIINGU: async function () {
                this.$router.push({
                    path: "/home/task/answer",
                    query: {
                        outlineInfo: JSON.stringify({
                            courseId: this.course.id, 
                            courseName: this.course.name,
                            courseOutlineId: this.activeMenu,
                            chapterName: this.material.chapterName
                        }),
                    },
                });
            },

            previousDataNone: function () {
                if (this.material.prevId == null) return;
                this.setActiveID(this.material.prevId);
            },

            nextDataNone: function () {
                if (this.material.nextId == null) return;
                this.setActiveID(this.material.nextId);
            },
			
			// Get data all pages
			convertDataPags: function (data) {
				const contents = data.reduce((a, v) => {
                    let length = v.type != 2 ? 1: v.mnum;
					let pages = Array.from({ length: length }).map((x, i) => ({
						id: v.id,
						type: v.type,
						pageReal: ++i,
                        enable: (v.type == 2 && i > v.currentNum) || v.currentNum == 0 ? false : true,
					}));

					a = a.concat(pages);
					return a;
				}, []);

				return contents.map((item, index) => ({ ...item, page: ++index }));
			},
			
			changePhase: function (data) {
				if (this.activeID != data.id) {
                    this.activeID = data.id;
                    this.jumpS = true;
                } else {
                    this.page = data.pageReal;
                    this.jump(data.pageReal);
                }
			},
            
            findPage: function () {
                let page = 1;
                if (this.pags.length) {
                    let key = this.pags.findIndex(item => item.id == this.activeID && item.pageReal == this.page);
                    // console.log(`page: ${this.pags[key].page}`);
                    page = this.pags[key].page;
                }
                return page;
            },

            resetZoom: function () {
                this.value = 0; 
                this.value1 = 0;
            }
        },
    };
</script>

<style scoped>
    .slider-zoom {
        width: 70%;
        display: flex;
        margin: 0 16px;
    }
    .nqt-precent {
        font-size: 14px;
        font-weight: 700;
        display: flex;
        align-items: center;
    }
    span.pgn {
        font-size: 14px;
        font-weight: 300;
    }
    .select-new {
        width: auto !important;
        margin-top: 0 !important;
    }
    .btn-item {
        width: 15%;
        height: 100%;
        display: flex;
        cursor: pointer;
        align-items: center;
        justify-content: center;
    }
    .btn-item._top {
        width: 30%;
    }
    .btn-item img {
        width: 46px;
        margin: auto;
    }
    .container {
        width: 100%;
        height: 100%;
        position: relative;
    }
    ._controll {
        height: 60px;
        display: flex;
        align-items: center;
        justify-content: space-around;
    }
    ._controll_top {
        display: flex;
        height: 40px;
        align-items: center;
        justify-content: center;
    }
    .lesson-content {
        position: relative;
        width: 98%;
        left: 1%;
        height: calc(100% - 100px);
        border-radius: 5px;
        box-shadow: 0px 1px 10px 1px rgba(0, 0, 0, 0.45);
        display: flex;
        overflow: auto;
    }
    .lesson-content img{
        margin: auto;
        max-width: 100%;
    }
    .loading {
        position: absolute;
        top: 50%;
        left: 50%;
        background-color: rgb(38 50 56 / 0%);
        transform: translate(-50%, -50%);
    }

    ::-webkit-scrollbar {
        width: 10px;
        height: 10px;
        cursor: pointer;
    }

    ::-webkit-scrollbar-thumb:horizontal {
        background-image: -webkit-gradient(linear, left bottom, left top, color-stop(0.44, rgb(112, 161, 155)), color-stop(0.72, rgb(30, 144, 255)), color-stop(0.86, rgb(30, 144, 255)));
    }
    ::-webkit-scrollbar-thumb:vertical {
        background-image: -webkit-gradient(linear, left bottom, left top, color-stop(0.44, rgb(112, 161, 155)), color-stop(0.72, rgb(30, 144, 255)), color-stop(0.86, rgb(30, 144, 255)));
    }
    .disabled_nqt {
        background-color: gray;
        color: white;
    }
</style>



// WEBPACK FOOTER //
// src/components/learn/contentLearnMobile.vue